import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import ReduxPromise from 'redux-promise';
import thunk from 'redux-thunk';

import rootReducer from '../reducers'
 
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'systemAdmin', 'hradmin', 'appConfig'],
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)

let store = createStore(persistedReducer, compose(applyMiddleware(ReduxPromise, thunk)));
let persistor = persistStore(store);

export { store, persistor };